import styled from "styled-components";

export const ImageLoaderSpan = styled.span<{ show: boolean }>`
  display: ${({ show }) => (!show ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: #212225;
`;

export const ImageLoaderImg = styled.img`
  display: block;
  width: 50px;
  height: 50px;
  display: block;
  margin: 0 auto;
`;
